module.exports = __webpack_public_path__ + "img/گارت-ویزیت.9df7c548.png";